import { useState } from 'react'
import cx from 'classnames'
import Dropdown from 'rc-dropdown'
import Menu, { Item as MenuItem } from 'rc-menu'

import Button from 'common/components/button'
import ConfirmationModal from 'common/components/confirmationModal/ConfirmationModal'
import { Bin, Edit, MoreOptionsVertical } from 'common/icons'

import useDeleteLanguageRuleMutation from '../../../api/mutations/useDeleteLanguageRuleMutation'

type Props = {
  ruleId: string
  onEdit: () => void
}

const LanguageRulesActions = ({ ruleId, onEdit }: Props) => {
  const [showDeleteRuleModal, setShowDeleteRuleModal] = useState<boolean>(false)
  const { mutate, isLoading } = useDeleteLanguageRuleMutation({
    ruleId,
    onSuccess: () => {
      setShowDeleteRuleModal(false)
    },
  })

  return (
    <>
      <Dropdown
        trigger={['click']}
        overlay={
          <Menu
            className="p-2 z-40 bg-gold-40 border-base-700"
            selectable={false}
          >
            <MenuItem
              onClick={() => {
                if (!isLoading) {
                  onEdit()
                }
              }}
              aria-label="Edit rule"
              disabled={isLoading}
              className="flex hover:bg-gold-300 text-xs text-base-700 cursor-pointer"
            >
              <Edit
                isDefaultColor={false}
                size={4}
                className="mr-4 text-base-700"
              />
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                if (!isLoading) {
                  setShowDeleteRuleModal(true)
                }
              }}
              aria-label="Delete rule"
              disabled={isLoading}
              className={cx(
                {
                  'cursor-not-allowed': isLoading,
                  'cursor-pointer': !isLoading,
                },
                'flex hover:bg-gold-300 text-xs text-base-700'
              )}
            >
              <Bin
                isDefaultColor={false}
                size={4}
                className="mr-4 text-base-700"
              />
              Delete
            </MenuItem>
          </Menu>
        }
      >
        <Button
          variant="icon"
          data-testid="Rule actions"
          suffixIcon={
            <MoreOptionsVertical
              isDefaultColor={false}
              className="text-base-700"
            />
          }
        ></Button>
      </Dropdown>
      <ConfirmationModal
        data-testid="remove-rule-modal"
        title="Delete rule"
        confirmationText={`Are you sure you want to delete this rule? Existing content won't be updated, you will need to update existing content manually.`}
        confirmButtonText="YES, DELETE"
        cancelButtonText="CANCEL"
        open={showDeleteRuleModal}
        hasConfirmationSlider={true}
        onConfirm={() => mutate()}
        onCancel={() => setShowDeleteRuleModal(false)}
        isLoading={isLoading}
      />
    </>
  )
}

export default LanguageRulesActions
